import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import React from 'react';
import { AvatarURLDetail, TnAvatar } from '../TnAvatar';
import { TnTypography } from '../TnTypography';

export interface PersonnelHeaderDetails {
  firstName: string;
  lastName: string;
  personTitle: string;
  avatarURLDetail?: AvatarURLDetail;
}

interface PersonnelHeaderProps extends PersonnelHeaderDetails {
  handleClose: () => void;
}

const PersonnelHeader = ({ firstName, lastName, personTitle, handleClose, avatarURLDetail }: PersonnelHeaderProps) => {
  const classes = useStyles();

  return (
    <Grid className={classes.headerContainer}>
      <Grid className={classes.userInfoContainer}>
        <Grid className={classes.avatarContainer}>
          {avatarURLDetail ? (
            <TnAvatar
              isCompletePath={avatarURLDetail.isCompleteURLPath}
              src={avatarURLDetail.avatarURL}
              name={`${firstName} ${lastName}`}
              className={classes.avatar}
            />
          ) : (
            <TnAvatar name={`${firstName} ${lastName}`} />
          )}
        </Grid>
        <Grid container className={classes.headerTitleContainer}>
          <TnTypography isParagraph={false} variant="h6">
            {`${firstName} ${lastName}`}
          </TnTypography>
          <TnTypography isParagraph={false} variant="caption2" color="darkGrey">
            {`${personTitle}`}
          </TnTypography>
        </Grid>
      </Grid>
      <Grid item>
        <Close className={classes.closeButton} onClick={handleClose} data-testid={'Modal_Close'} />
      </Grid>
    </Grid>
  );
};

export default PersonnelHeader;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      width: '100%',
      paddingLeft: 32,
      paddingRight: 32,
      paddingTop: 24,
      paddingBottom: 24,
    },
    userInfoContainer: { display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' },
    avatarContainer: { alignContent: 'flex-start', justifyContent: 'flex-start', alignItems: 'flex-start' },
    avatar: { height: 56, width: 56 },
    headerTitleContainer: {
      marginLeft: 16,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
    },
    closeButton: {
      color: theme.palette.text.primary,
      cursor: 'pointer',
    },
  }),
);
